import Request from './request'

async function fetchByTemplate (id, data) {
  return Request(
    'get',
    'api/food-template-relations/view-by-template/' + id,
    data
  )
}

export default {
  fetchByTemplate,
}
